import React from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MaskedInput from 'react-text-mask';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const DateMaskInput = ({ inputRef, ...other }) => {
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      keepCharPositions
      guide
    />
  );
};

DateMaskInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export const DateInput = ({ input, meta: { touched, error }, ...custom }) => {
  return (
    <FormControl required={custom.required} fullWidth={custom.fullWidth}>
      <InputLabel htmlFor={custom.name}>{custom.label}</InputLabel>
      <Input
        type="text"
        id={custom.name}
        inputComponent={DateMaskInput}
        {...input}
        {...custom}
      />
      {touched &&
        error && (
          <FormHelperText error id={`${custom.name}-error`}>
            {error}
          </FormHelperText>
        )}
    </FormControl>
  );
};

export default DateInput;
